interface Group {
  uuid: string;
  name: string;
  initials: string;
  member_count: number;
  color: string;
  members: any[];
  [key: string]: any;
}

export const formatGroups = (
  groups: Group[],
  membersTranslated: string
): Array<{
  uuid: string;
  primary: string;
  initials: string;
  secondary: string;
  color: string;
  members: any[];
  data: Group;
}> => {
  const formattedGroups = groups.map((group: Group) => {
    console.log(group, 'group');
    return {
      uuid: group.uuid,
      primary: group.name,
      initials: group.initials,
      secondary: `${group.member_count} ${membersTranslated}`,
      members: group.members,
      color: group.group_color,
      data: { ...group }
    };
  });
  return formattedGroups;
};
